import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import SkeletonBar from '../SkeletonBar'

const SkeletonTeaserInfo = (): ReactElement => {
    return (
        <Grid horizontal noExpand>
            <Grid noExpand width={16} height={16} backgroundColor="moon-3" borderRadius={4} />
            <SkeletonBar width={76} height={12} marginTop={1} marginLeft={3} />
        </Grid>
    )
}

export default memo(SkeletonTeaserInfo)
